import { render } from "./DestroyVM.vue?vue&type=template&id=e5b97630&scoped=true"
import script from "./DestroyVM.vue?vue&type=script&lang=js"
export * from "./DestroyVM.vue?vue&type=script&lang=js"

import "./DestroyVM.vue?vue&type=style&index=0&id=e5b97630&scoped=true&lang=less"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b97630"]])

export default __exports__